<template>
<v-card flat style="overflow-x: hidden;">
    <v-tabs v-model="activeTab" grow light show-arrows="mobile">
        <v-tabs-slider color="green"></v-tabs-slider>
        <v-tab class="pl-1 pr-1"><v-icon class="mr-1">mdi-calendar</v-icon><span class="hidden-sm-and-down">Evenement</span></v-tab>
        <v-tab class="pl-1 pr-1"><v-icon class="mr-1">mdi-clock-time-eight-outline</v-icon><span class="hidden-sm-and-down">Temps</span></v-tab>
        <v-tab class="pl-1 pr-1"><v-icon class="mr-1">mdi-file</v-icon><span class="hidden-sm-and-down">Fichiers</span></v-tab>
    </v-tabs>
    <v-card v-if="activeTab === 0 && item" flat>
        <v-card-text class="ma-3">
        <v-row>
            <v-col cols="6" md="6">
                <v-row>
                    <v-col cols="12" lg="6" md="6" sm="12">
                        <DatePicker label="Date début" :objectForm="item" fieldName='eve_date_start'></DatePicker>
                    </v-col>
                    <v-col cols="12" lg="6" md="6" sm="12">
                        <DatePicker label="Date fin" :objectForm="item" fieldName='eve_date_end'></DatePicker>
                    </v-col>
                    <v-col cols="12" md="12">
                        <v-text-field label="Objet" prepend-icon="mdi-script-text-outline" placeholder="Titre" v-model="item.eve_title"></v-text-field>
                    </v-col>
                    <!--<v-col cols="12" md="12">
                        <v-select v-if="!loading.fetchData" :items="priorities" item-text="typ_name" item-value="typ_id" v-model="item.eve_typ_id_priority"
                                label="Priorité" single-line prepend-icon="mdi-flag-outline">
                        </v-select>
                    </v-col>-->
                </v-row>    
            </v-col>
            <v-col cols="6" md="6" class="pt-0 pb-0 pl-1">
                <v-col cols="12" md="12" align="center" justify="center" class="pt-0 pb-0">
                    <v-icon v-show="(!uploadedImage && !resizeImage && !item.eve_doc_id_image)" size="10em" @click="$refs.inputUpload.click()">mdi-camera</v-icon>
                    <img ref="imgSrc" :src="uploadedImageSrc" v-show="false" />
                    <v-img ref="resizedImage" max-width="100%" max-height="20em" style="cursor:pointer;"
                            v-show="(uploadedImage || item.eve_doc_id_image)" :src="resizedImage" aspect-ratio="1" @click="$refs.inputUpload.click()" class="elevation-3 rounded-lg">
                    </v-img>
                    <v-progress-circular v-if="resizeImage" :size="100" :width="5" color="primary" indeterminate></v-progress-circular>
                    <input ref="inputUpload" v-show="false" accept="image/*" type="file" @change="handleImageImport()" /> 
                </v-col>
            </v-col>
        </v-row>
        <v-row class="pr-6">
            <v-col cols="12" md="12" class="pl-2 pr-2">
                <AutocompleteMulti 
                    :title="'Agent(s) affectés'" :ressource="'users'" :disabled="disableForm"
                    :listObject.sync="item._pivot.users" :listParent.sync="autoCompleteSource.userList" 
                    :fields="{
                        index: 'id', text:'lastName,firstName', autofocus: false, deletablechips: true,
                        search:'usr_middleName', preprendIcon:'mdi-account-group', multiSelect:true, prefetch: true, params:'' 
                }"></AutocompleteMulti>
            </v-col>
            <v-col cols="12" md="12" class="pl-2 pr-2">
                <AutocompleteMulti 
                    :title="'Matériel affecté'" :ressource="'equipments'" :disabled="disableForm"
                    :listObject.sync="item._pivot.equipments" :listParent.sync="autoCompleteSource.equipmentList" 
                    :fields="{
                        index: 'equ_id', text:'equ_name', autofocus: false, deletablechips: true,
                        search:'equ_name', preprendIcon:'mdi-tools', multiSelect:true, prefetch: true, params:'' 
                }"></AutocompleteMulti>
            </v-col>
            <v-col cols="4" lg="4" md="4" sm="4">
                <v-text-field label="Durée" prepend-icon="mdi-clock-outline" v-model="item.eve_duration" type="time" dense outlined :disabled="!hasAssignments"></v-text-field>
            </v-col>
            <v-col cols="4" lg="4" md="4" sm="4">
                <v-text-field label="Heure matin" prepend-icon="mdi-weather-sunset-up" v-model="item.eve_duration_am" type="time" dense outlined :disabled="!hasAssignments"></v-text-field>
            </v-col>
            <v-col cols="4" lg="4" md="4" sm="4">
                <v-text-field label="Heure après-midi" prepend-icon="mdi-weather-sunset-down" v-model="item.eve_duration_pm" type="time" dense outlined :disabled="!hasAssignments"></v-text-field>
            </v-col>
            <v-col cols="8" md="8">
                <v-col cols="12" md="12">
                    <v-select v-if="!loading.fetchData" :items="taskTypes" item-text="tty_name" item-value="tty_id" v-model="item.eve_tty_id" 
                            label="Type de tâche" single-line prepend-icon="mdi-format-list-bulleted-type">   
                    </v-select>
                </v-col>
                <v-col cols="12" md="12" v-if="item.eve_typ_id && item.eve_typ_id.substring(0,3) == 'MEV'">
                    <v-text-field label="Numero devis" prepend-icon="mdi-currency-eur" v-model="item.eve_custom_fields.eve_quotation_id"></v-text-field>
                </v-col>
                <v-col cols="12" md="12" v-if="item.eve_typ_id && item.eve_typ_id.substring(0,3) == 'MEV'">
                    <v-text-field label="Montant" prepend-icon="mdi-currency-eur" v-model="item.eve_cost_value"></v-text-field>
                </v-col>
                <!-- <v-col cols="3" md="3">
                    <v-switch v-model="item.eve_delegation" inset label="Sous traité"></v-switch>
                </v-col> -->
                <v-col cols="12" md="12">
                    <v-textarea rows="2" auto-grow prepend-icon="mdi-comment" label="Description" v-model="item.eve_description"></v-textarea>
                </v-col>
                <!--<v-col cols="12" md="12">
                    <v-subheader class="pl-0">Résolution / avancement</v-subheader>
                    <v-slider class="mx-3" v-model="item.eve_resolve_percent" :step="10" thumb-label="always">
                    </v-slider>
                </v-col>-->
            </v-col>
            <!-- Re-programmation : une date choisie ici crée une nouvelle tâche à la clôture ("Terminer") -->
            <v-col cols="4" md="4" v-if="item.eve_sta_id == 'GEN01'">
                <v-row align="center">
                    <v-col cols="12" md="12">
                        <DatePicker label="Re-programmer la tâche au" :objectForm="reschedule" fieldName="date"
                            :disabled="disableForm"></DatePicker>
                    </v-col>
                    <v-col cols="12" md="12">
                        <div class="text-caption grey--text">
                            <v-icon small color="info" class="mr-1">mdi-information-outline</v-icon>
                            Choisissez une date pour re-programmer cette tâche : en cliquant sur «&nbsp;Terminer&nbsp;». Laissez le champ vide pour clôturer sans re-programmer.
                        </div>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        </v-card-text>
        <v-card-actions style="background-color:#E5E5E5;">
            <v-btn rounded class="ma-0" color="error" @click.native="item.eve_sta_id = 'GEN03'; deleteEvent()" :disabled="saveProgress">
                <v-icon left>mdi-record</v-icon>Supprimer
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn rounded text color="grey" @click="switchModal('modalEvent', 0)">
                <v-icon left dark>mdi-close</v-icon>Annuler
            </v-btn>
            <v-btn v-if="item.eve_sta_id == 'GEN01'" rounded color="orange" :loading="saveProgress" 
                @click.native="saveEvent('GEN03')" :disabled="saveProgress" class="ml-3">
                <v-icon left dark>mdi-check</v-icon>Terminer
            </v-btn>
            <v-btn v-if="item.eve_sta_id == 'TSK02'" rounded color="orange" :loading="saveProgress" 
                @click.native="saveEvent('TSK03')" :disabled="saveProgress" class="ml-3">
                <v-icon left dark>mdi-check</v-icon>Accepter
            </v-btn>
            <v-btn rounded color="success" :loading="saveProgress" @click.native="saveEvent()" :disabled="saveProgress" class="ml-3">
                <v-icon left dark>mdi-content-save-outline</v-icon>Enregistrer
            </v-btn>
        </v-card-actions>
    </v-card>
    <WorktimeTab v-if="activeTab === 1" :event="item" @computeduration="onComputedDuration" />
    <DocumentTab v-if="activeTab === 2 && showTab == true && item.eve_id > 0" :doc_xxx_id="item.eve_id" :table_id="'eve'"
        :routeState="{ siteView:false, siteEdit:true, view:false, edit:true, add:true, state: 'modifier' }" style="min-height: 474px;">
    </DocumentTab>
    </v-card>
</template>

<script>
import { mapState, mapActions, mapWritableState } from 'pinia'
import { useEventStore } from '@/stores/event'
import { useDocumentStore } from '@/stores/document'
import { useTypeStore } from '@/stores/type'
import { useTaskTypeStore } from '@/stores/tasktype'
import { useStateStore } from '@/stores/state'
import { useUserStore } from '@/stores/user'
import { useTeamStore } from '@/stores/team'
import { useEquipmentStore } from '@/stores/equipment'
import DatePicker from '@/components/ui/DatePicker'
import DocumentTab  from '@/components/documents/DocumentList.vue'
import WorktimeTab from '@/components/worktimes/WorktimeList.vue'
import AutocompleteMulti from '@/components/ui/AutocompleteMulti'
import Pica from "pica"

export default {
    name: 'event-edit',
    components: { DocumentTab, DatePicker, WorktimeTab, AutocompleteMulti },
    props: ['xxxId', 'eveId', 'eveTable', 'eveType', 'switchModal', 'cooridnates', 'lraId'],
    computed: {
        ...mapWritableState(useEventStore, { item: 'item' }),
        ...mapState(useDocumentStore, { documentItem: 'item' }),
        ...mapState(useTypeStore, {typeListByGroup: 'itemListByGroup', typeListById: 'itemListById' }),
        ...mapState(useTaskTypeStore, {taskTypeList: 'itemList' }),
        ...mapState(useStateStore, {stateListByGroup: 'itemListByGroup', stateListById: 'itemListById' }),
        ...mapState(useUserStore, {userList: 'itemList', user: 'me' }),
        ...mapState(useTeamStore, {teamDefaultUsers: 'defaultUsers' }),
        ...mapState(useEquipmentStore, {equipmentList: 'itemList' }),
        disableForm(){
            if(this.loading.fetchData){
                return true
            } else {
                return (this.item.eve_sta_id == 'GEN05')
            }
        },
        // Durées activées si des agents OU du matériel sont affectés
        hasAssignments(){
            return ((this.item._pivot.users && this.item._pivot.users.length > 0) ||
                    (this.item._pivot.equipments && this.item._pivot.equipments.length > 0))
        },
    },
    watch: {
        // Dispatch : si le total est modifié manuellement, on divise par 2 pour matin / après-midi
        'item.eve_duration': {
            handler (val) {
                // Ne pas ré-écraser matin/après-midi quand le total vient d'être recalculé depuis eux
                if( this.updatingFromHalf ){
                    this.updatingFromHalf = false
                    return
                }
                if( val && val !== '00:00' && val !== '00:00:00' ){
                    let half = this.halfDuration(val)
                    this.item.eve_duration_am = half
                    this.item.eve_duration_pm = half
                }
            }
        },
        // Si matin / après-midi sont remplis, on recalcule le total
        'item.eve_duration_am': {
            handler () { this.recomputeTotalDuration() }
        },
        'item.eve_duration_pm': {
            handler () { this.recomputeTotalDuration() }
        }
    },
    data: function () {
        return {
            loading: { fetchData: true },
            autoCompleteSource: { listTaskTypeItemSource: [], userList: [], equipmentList: [] },
            dateMenu: { date_start:false, date_end:false },
            saveProgress: false,         // Enregistrement en cours...
            updatingFromHalf: false,     // Garde-fou : total recalculé depuis matin/après-midi
            states : [],
            types : [],
            taskTypes : [],
            priorities : [],
            dateEve: { start: false, end: false },
            optionMenu: false,
            reschedule: { date: null },   // Date de re-programmation (appliquée uniquement via "Terminer")
            eventType: {
                'pro' : [ 'ACT' ],
                'act' : [ 'ALT' ],
                'mev' : [ 'MEV' ],
                'cad' : [ 'ACT' ],
            },
            activeTab: 0, showTab: true,
            uploadedImage: false,
            resizeImage: false,
            resizedImage: '',
            uploadedImageSrc: ''
        }
    },
    //beforeMount: function(){ },
    async mounted() {
        this.loading.fetchData = true
        this.autoCompleteSource.userList = this.userList
        this.priorities = this.typeListByGroup['EVP'] || []

        // Chargement du matériel disponible (pour l'autocomplete "Matériel affecté")
        try {
            await this.fetchEquipments('?per_page=false')
            this.autoCompleteSource.equipmentList = this.equipmentList
        } catch(e) {
            console.log('fetchEquipments error:', e)
        }

        // Chargement des types de tâche (filtrés par layer si disponible)
        await this.fetchTaskTypes( (this.lraId) ? '?lra_id=' + this.lraId + '&per_page=false' : '?per_page=false' )
        this.taskTypes = this.taskTypeList

        if ( this.eveType ){
            this.types = this.typeListByGroup[this.eveType]
        } else {
            this.types = this.typeListByGroup['ALT']
        }
        if( this.eveId !== undefined && this.eveId > 0 ){
            await this.fetchItem( this.eveId, '?include=users,equipments' ).then( () => {
                if( this.item.eve_doc_id_image > 0 ){
                    this.getImage(this.item.eve_doc_id_image)
                }
                this.types = this.typeListByGroup[this.eventType[this.item.eve_table_id]]
            })

        } else {
            this.RESET_ITEM()
            this.item.eve_id         = 0
            this.item.eve_typ_id     = this.types[0].typ_id
            this.item.eve_tty_id     = (this.taskTypes[0]) ? this.taskTypes[0].tty_id : null
            this.item.eve_table_id   = this.eveTable
            this.item.eve_xxx_id     = this.xxxId
            this.item.eve_date_start = this.$date().format('YYYY-MM-DD')
            // Pré-affectation des membres d'équipe si l'utilisateur est TEAM_LEADER
            if( this.user.role === 'TEAM_LEADER' ){
                try {
                    const defaultUsers = await this.fetchDefaultUsers()
                    if( defaultUsers && Array.isArray(defaultUsers) ){
                        this.item._pivot.users = defaultUsers.map(u => u.id)
                        // Alimente la liste source de l'autocomplete avec les users par défaut
                        this.autoCompleteSource.userList = this.mergeUsers(this.autoCompleteSource.userList, defaultUsers)
                    }
                } catch(e) {
                    console.log('fetchDefaultUsers error:', e)
                }
            }
        }
        if( this.cooridnates && this.cooridnates.lat && this.cooridnates.lng ){
            this.item.eve_lat = this.cooridnates.lat
            this.item.eve_lng = this.cooridnates.lng
        }
        this.loading.fetchData = false
        
    },
    methods: {
        ...mapActions(useEventStore, ['fetchItem', 'storeItem', 'storeMulti', 'updateItem', 'destroyItem', 'RESET_ITEM']),
        ...mapActions(useTaskTypeStore, { fetchTaskTypes: 'fetchItems' }),
        ...mapActions(useEquipmentStore, { fetchEquipments: 'fetchItems' }),
        ...mapActions(useDocumentStore, { storeItemWithFile: 'storeItemWithFile', documentUpdateItem: 'updateItem' }),
        ...mapActions(useTeamStore, { fetchDefaultUsers: 'fetchDefaultUsers' }),
        saveEvent(state){
            this.saveProgress = true
            const eveId = this.item.eve_id
            // Tâche pas encore enregistrée (création) : on crée d'abord la tâche pour
            // obtenir son ID (nécessaire pour les agents / heures), puis on applique
            // l'état demandé (Terminer / Accepter) et on lance les enregistrements liés
            if( state && (eveId === undefined || eveId <= 0) ){
                this.storeItem().then( () => {
                    this.$root.$toast({ color: 'success', text: 'Fiche enregistrée !' })
                    this.saveEvent(state)
                }).catch( (error) => {
                    this.$root.$toast({ color: 'error', text: 'Erreur lors de l\'enregistrement : ' + error })
                    this.saveProgress = false
                })
                return
            }
            // Re-programmation : à la clôture ("Terminer"), enregistre/clôture d'abord
            // la tâche en cours, puis réutilise l'item pour créer la copie à la date choisie
            if( state == 'GEN03' && this.reschedule.date && eveId > 0 ){
                const newDate    = this.reschedule.date
                const users      = (this.item._pivot.users) ? [...this.item._pivot.users] : []
                const equipments = (this.item._pivot.equipments) ? [...this.item._pivot.equipments] : []
                const origStart  = this.item.eve_date_start
                const origEnd    = this.item.eve_date_end
                const durationAm = this.item.eve_duration_am
                const durationPm = this.item.eve_duration_pm
                // 1. Enregistre la tâche en cours (clôturée)
                this.item.eve_sta_id = 'GEN03'
                this.updateItem().then( () => {
                    // 2. Transforme l'item en nouvelle tâche : date choisie, état actif, id à 0
                    this.item.eve_id         = 0
                    this.item.eve_sta_id     = 'GEN01'
                    this.item.eve_date_start = newDate
                    // Décale la date de fin en conservant la durée de la tâche
                    if( origStart && origEnd ){
                        let diffDays = Math.round((new Date(origEnd) - new Date(origStart)) / 86400000)
                        let newEnd   = new Date(newDate)
                        newEnd.setDate(newEnd.getDate() + diffDays)
                        this.item.eve_date_end = newEnd.toISOString().slice(0, 10)
                    } else {
                        this.item.eve_date_end = null
                    }
                    // La copie repart à zéro sur les éléments de réalisation
                    // (eve_resolve_percent est NOT NULL en base : 0 et pas null)
                    this.item.eve_doc_id_image    = null
                    this.item.eve_resolve_percent = 0
                    // updateItem (SET_ITEM) a vidé _pivot.users/_pivot.equipments et les
                    // durées am/pm (absents de la réponse) -> on les restaure pour la copie
                    this.item.eve_duration_am  = durationAm
                    this.item.eve_duration_pm  = durationPm
                    this.item._pivot.users     = users
                    this.item._pivot.equipments = equipments
                    // 3. Crée la nouvelle tâche
                    this.storeItem().then( () => {
                        this.$root.$toast({ color: 'success', text: 'Tâche clôturée et re-programmée au ' + this.$date(newDate).format('DD/MM/YYYY') })
                        this.reschedule.date = null
                        this.switchModal('modalEvent', 0, true)
                        this.saveProgress = false
                    }).catch( (error) => {
                        this.$root.$toast({ color: 'error', text: 'Erreur lors de la re-programmation : ' + error })
                        this.saveProgress = false
                    })
                }).catch( (error) => {
                    this.$root.$toast({ color: 'error', text: 'Erreur lors de la clôture : ' + error })
                    this.saveProgress = false
                })
                return
            }
            if( eveId !== undefined && eveId > 0 ){
                this.item.eve_sta_id = ( state ) ? state : this.item.eve_sta_id
                this.updateItem().then( () => {
                    this.$root.$toast({ color: 'success', text: 'Fiche enregistrée !' })
                    if( this.uploadedImage ){
                        this.documentItem.doc_xxx_id   = eveId
                        this.documentItem.doc_table_id = 'eve'
                        this.documentItem.doc_typ_id   = 'DOC03'
                        this.saveDocument().then( () => {
                            this.attachDocument(eveId, this.documentItem.doc_id).catch( (error) => {
                                console.log('attachDocument error:', error)
                                this.$root.$toast({ color: 'error', text: 'Erreur lors de l\'attribution de l\'image' })
                            })
                        })
                    }
                    this.switchModal('modalEvent', 0, true)
                    this.saveProgress = false
                })
            } else if( this.item.eve_xxx_id && Object.prototype.toString.call( this.item.eve_xxx_id ) === '[object Array]' && this.item.eve_xxx_id.length > 0 ){
                // Création multiple : un événement par objet sélectionné
                this.storeMulti( this.item ).then( () => {
                    this.$root.$toast({ color: 'success', text: 'Fiche(s) enregistrée(s) !' })
                    this.switchModal('modalEvent', 0, true)
                    this.saveProgress = false
                }).catch( (error) => {
                    this.$root.$toast({ color: 'error', text: 'Erreur lors de l\'enregistrement : ' + error })
                    this.saveProgress = false
                })
            } else {
                this.storeItem().then( () => {
                    this.$root.$toast({ color: 'success', text: 'Fiche enregistrée !' })
                    const newEveId = this.item.eve_id
                    if( this.uploadedImage ){
                        this.documentItem.doc_xxx_id   = newEveId
                        this.documentItem.doc_table_id = 'eve'
                        this.documentItem.doc_typ_id   = 'DOC03'
                        this.saveDocument().then( () => {
                            this.attachDocument(newEveId, this.documentItem.doc_id).catch( (error) => {
                                console.log('attachDocument error:', error)
                                this.$root.$toast({ color: 'error', text: 'Erreur lors de l\'attribution de l\'image' })
                            })
                        })
                    }
                    this.switchModal('modalEvent', 0, true)
                    this.saveProgress = false
                })
            }
        },
        deleteEvent(){
            this.$root.$confirm('Supprimer cet évènement', 'Confirmez vous cette action ?', { color: 'red', width: 400 }).then((confirm) => {
                if( confirm && this.item.eve_id > 0 ){
                    this.destroyItem().then( () => {
                        this.switchModal('modalEvent', 0, true)
                    })
                }
            })
                
        },
        getImage(doc_id){
            this.$http.customRequest({ method: 'get', url: 'documents/' + doc_id + '/download', responseType: 'blob' } )
            .then( (response) => {
                if( response.status == 204 ){
                    this.$root.$toast({ color: 'warning', text: 'Le fichier image n\'existe pas' })
                } else {
                    var reader = new FileReader();
                    reader.readAsDataURL(response.data); 
                    reader.onloadend = () => {
                        var base64data   = reader.result;                
                        this.resizedImage = base64data;
                    }
                }
            }).catch( (error) => {
                this.$root.$toast({ color: 'error', text: error })
            })
        },
        handleImageImport(){
            this.resizeImage      = true
            const pica            = Pica();
            var files             = this.$refs.inputUpload.files
            this.uploadedImageSrc = window.URL.createObjectURL(files[0])

            setTimeout( () => {
                let dim = this.calculateAspectRatioFit(this.$refs.imgSrc.width, this.$refs.imgSrc.height, 720, 1080)

                const resizedCanvas  = document.createElement("canvas")
                resizedCanvas.height = dim.height
                resizedCanvas.width  = dim.width

                pica.resize(this.$refs.imgSrc, resizedCanvas).then(result => {
                    this.resizedImage  = result.toDataURL()
                    pica.toBlob(result, 'image/jpeg', 0.85).then( (blob) => {
                        blob.name = files[0].name
                        this.documentItem.doc_name = files[0].name
                        this.documentItem.obj_file = blob
                    })
                    // Update states
                    this.resizeImage   = false
                    this.uploadedImage = true
                })
                .catch(error => {
                    console.log(error);
                });
            }, 500)

        },
        calculateAspectRatioFit(srcWidth, srcHeight, maxWidth, maxHeight) {
            var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight);
            return { width: srcWidth * ratio, height: srcHeight * ratio };
        },
        // Fusionne deux listes d'utilisateurs en dédoublonnant sur l'id
        mergeUsers(existing, additional){
            const map = new Map()
            ;(existing || []).forEach(u => map.set(u.id, u))
            ;(additional || []).forEach(u => map.set(u.id, u))
            return Array.from(map.values())
        },
        // Divise une durée "HH:MM" par 2 (arrondi à la minute)
        halfDuration(duration){
            let parts = (duration || '00:00').split(':')
            let totalMinutes = parseInt(parts[0], 10) * 60 + parseInt(parts[1] || 0, 10)
            let half = Math.round(totalMinutes / 2)
            let h = Math.floor(half / 60)
            let m = half % 60
            return String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0')
        },
        // Recalcule le total à partir de matin + après-midi
        recomputeTotalDuration(){
            let am = (this.item.eve_duration_am && this.item.eve_duration_am !== '00:00') ? this.item.eve_duration_am : '00:00'
            let pm = (this.item.eve_duration_pm && this.item.eve_duration_pm !== '00:00') ? this.item.eve_duration_pm : '00:00'
            let amParts = am.split(':')
            let pmParts = pm.split(':')
            let totalMinutes = parseInt(amParts[0], 10) * 60 + parseInt(amParts[1] || 0, 10)
                + parseInt(pmParts[0], 10) * 60 + parseInt(pmParts[1] || 0, 10)
            let h = Math.floor(totalMinutes / 60)
            let m = totalMinutes % 60
            // Marque le recalcul pour que le watcher du total ne ré-écrase pas matin/après-midi
            this.updatingFromHalf = true
            this.item.eve_duration = String(h).padStart(2, '0') + ':' + String(m).padStart(2, '0')
        },
        // Durée recalculée depuis l'onglet Temps (somme des temps saisis) :
        // met à jour "Durée" sans re-découper matin/après-midi
        onComputedDuration(duration){
            this.updatingFromHalf = true
            this.item.eve_duration = duration
            this.$nextTick( () => { this.updatingFromHalf = false } )
        },
        saveDocument(){
            return new Promise( (resolve) => {
                if( this.documentItem.doc_id !== undefined && this.documentItem.doc_id > 0 && !this.documentItem.obj_file ){
                    this.documentUpdateItem().then( () => {
                        this.$emit('update:docId', this.documentItem.doc_id)
                        resolve('resolved')
                    })
                } else {
                    this.storeItemWithFile().then( () => {
                        this.$emit('update:docId', this.documentItem.doc_id)
                        resolve('resolved')
                    })
                }
            })
        },
        attachDocument(eveId, doc_id){
            return new Promise( (resolve, reject) => {
                this.$http.put( '/events/' + eveId + '/picture', { eve_doc_id_image: doc_id } ).then( () => {
                    this.$root.$toast({ color: 'success', text: 'Image attribuée' })
                    this.$emit('linkDoc', doc_id)
                    resolve('resolved')
                }).catch( (error) => { 
                    reject(error)
                })
            })
        },
    }
}
</script>